import React from 'react';
import { Card, Col, Form as BootstrapForm, Button, Row, Spinner } from 'react-bootstrap';
import ImageUploadField from './ImageUploadField';

const FormComponent = ({
  assistencia,
  fieldChange,
  onSubmit,
  imageFiles = {},
  onImageFileSelect,
  onImageFileClear,
  loading = false,
  saving = false,
  isEdit = false,
  canWrite = true,
}) => {
  if (loading) {
    return (
      <Card className="mt-3">
        <Card.Body className="d-flex justify-content-center align-items-center py-5">
          <Spinner animation="border" variant="success" />
          <span className="ms-2 text-muted">Carregando assistência...</span>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mt-3">
      <Card.Body>
        <BootstrapForm>
          <h6 className="fw-bold mb-3">Dados Gerais</h6>
          <Row className="g-2 mb-3">
            <Col md={6}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Nome da empresa *</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="text"
                  placeholder="Ex: Master Calibrações"
                  value={assistencia.nome || ''}
                  onChange={(e) => fieldChange(e, 'nome', e.target.value)}
                  disabled={!canWrite}
                />
              </BootstrapForm.Group>
            </Col>
            <Col md={4}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Cidade *</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="text"
                  placeholder="Ex: Curitiba"
                  value={assistencia.cidade || ''}
                  onChange={(e) => fieldChange(e, 'cidade', e.target.value)}
                  disabled={!canWrite}
                />
              </BootstrapForm.Group>
            </Col>
            <Col md={2}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Estado *</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="text"
                  placeholder="UF"
                  maxLength={2}
                  value={assistencia.estado || ''}
                  onChange={(e) => fieldChange(e, 'estado', e.target.value.toUpperCase())}
                  disabled={!canWrite}
                />
              </BootstrapForm.Group>
            </Col>
          </Row>

          <h6 className="fw-bold mb-3">Contato</h6>
          <Row className="g-2 mb-3">
            <Col md={6}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Email principal *</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="email"
                  placeholder="contato@empresa.com"
                  value={assistencia.email || ''}
                  onChange={(e) => fieldChange(e, 'email', e.target.value)}
                  disabled={!canWrite}
                />
              </BootstrapForm.Group>
            </Col>
            <Col md={6}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Email Help Desk</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="email"
                  placeholder="helpdesk@empresa.com"
                  value={assistencia.emailhp || ''}
                  onChange={(e) => fieldChange(e, 'emailhp', e.target.value)}
                  disabled={!canWrite}
                />
              </BootstrapForm.Group>
            </Col>
          </Row>

          <h6 className="fw-bold mb-3">Valores</h6>
          <Row className="g-2 mb-3">
            <Col md={3}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Chave Assist. *</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  value={assistencia.valor ?? ''}
                  onChange={(e) => fieldChange(e, 'valor', e.target.value)}
                  disabled={!canWrite}
                />
              </BootstrapForm.Group>
            </Col>
            <Col md={3}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Help Desk</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  value={assistencia.valorhp ?? ''}
                  onChange={(e) => fieldChange(e, 'valorhp', e.target.value)}
                  disabled={!canWrite}
                />
              </BootstrapForm.Group>
            </Col>
            <Col md={3}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Loc Solution</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  value={assistencia.valorloc ?? ''}
                  onChange={(e) => fieldChange(e, 'valorloc', e.target.value)}
                  disabled={!canWrite}
                />
              </BootstrapForm.Group>
            </Col>
            <Col md={3}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Desconto</BootstrapForm.Label>
                <BootstrapForm.Control
                  type="number"
                  min="0"
                  step="0.01"
                  placeholder="Nenhum"
                  value={assistencia.desconto ?? ''}
                  onChange={(e) => fieldChange(e, 'desconto', e.target.value)}
                  disabled={!canWrite}
                />
              </BootstrapForm.Group>
            </Col>
          </Row>

          <h6 className="fw-bold mb-3">Identidade visual</h6>
          <Row className="g-3 mb-3">
            <Col md={6}>
              <ImageUploadField
                label="Logo"
                fieldKey="logo"
                existingUrl={assistencia.logo}
                file={imageFiles.logo}
                disabled={!canWrite}
                onFileSelect={onImageFileSelect}
                onClear={onImageFileClear}
              />
            </Col>
            <Col md={6}>
              <ImageUploadField
                label="Assinatura"
                fieldKey="assinatura"
                existingUrl={assistencia.assinatura}
                file={imageFiles.assinatura}
                disabled={!canWrite}
                onFileSelect={onImageFileSelect}
                onClear={onImageFileClear}
              />
            </Col>
          </Row>

          <h6 className="fw-bold mb-3">Configurações</h6>
          <Row className="g-2">
            <Col md={4}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Moeda</BootstrapForm.Label>
                <BootstrapForm.Select
                  value={assistencia.currency || 'BRL'}
                  onChange={(e) => {
                    const currency = e.target.value;
                    fieldChange(e, 'currency', currency);
                    fieldChange(e, 'format', currency === 'BRL' ? 'pt-BR' : 'en-US');
                  }}
                  disabled={!canWrite}
                >
                  <option value="BRL">BRL (Real)</option>
                  <option value="USD">USD (Dólar)</option>
                </BootstrapForm.Select>
              </BootstrapForm.Group>
            </Col>
            <Col md={4}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Formato</BootstrapForm.Label>
                <BootstrapForm.Select
                  value={assistencia.format || 'pt-BR'}
                  onChange={(e) => fieldChange(e, 'format', e.target.value)}
                  disabled={!canWrite}
                >
                  <option value="pt-BR">pt-BR</option>
                  <option value="en-US">en-US</option>
                  <option value="es-PY">es-PY</option>
                </BootstrapForm.Select>
              </BootstrapForm.Group>
            </Col>
            <Col md={4}>
              <BootstrapForm.Group className="mb-2">
                <BootstrapForm.Label>Status</BootstrapForm.Label>
                <BootstrapForm.Select
                  value={assistencia.status || 'ativo'}
                  onChange={(e) => fieldChange(e, 'status', e.target.value)}
                  disabled={!canWrite}
                >
                  <option value="ativo">Ativo</option>
                  <option value="inativo">Inativo</option>
                </BootstrapForm.Select>
              </BootstrapForm.Group>
            </Col>
          </Row>
        </BootstrapForm>
      </Card.Body>

      <Card.Footer className="d-flex">
        <Button
          className="me-2"
          variant="success"
          onClick={onSubmit}
          disabled={!canWrite || saving}
        >
          {saving ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Salvando...
            </>
          ) : (
            isEdit ? 'Salvar alterações' : 'Salvar'
          )}
        </Button>
        <Button
          variant="secondary"
          onClick={() => { window.history.back(); }}
          disabled={saving}
        >
          Cancelar
        </Button>
      </Card.Footer>
    </Card>
  );
};

export default FormComponent;
